import angular from 'angular'
import './style.scss'

document.write(require('./view.html').default);

angular.module("core.application.main").directive("core.application.main.directive.paginate", [
    function() {

        // PAYL-5171
        // This is an improved 'pagination' directive which supercedes the old one

        var expose = {};
        expose.restrict = "A";
        expose.templateUrl = "paginate.html";
        expose.scope = {
            paginate: "=",
        };

        expose.link = function($scope) {

            $scope.goToNextPage = function() {
                $scope.$emit("paginate:goToPage", $scope.nextPageParameters);
            };

            $scope.goToPreviousPage = function() {
                $scope.$emit("paginate:goToPage", $scope.previousPageParameters);
            };

            $scope.paginationVisible = function() {
                // either the next or previous page must exist for the pagination to be shown
                return ($scope.nextPageParameters || $scope.previousPageParameters) ? true : false;
            };

            $scope.queryStringToObject = function(queryString) {
                // The given link should look something like this:
                // https://adminapi-qa.paylater.touchcorp.net/portal/admin/ordertransactions?markedOrderDate=1494989219763&markedOrderId=100&limit=20&orderBy=ORDER_DATE&ascending=false&rel=previous&test=';
                // which will be parsed into this:
                // {
                //     markedOrderDate: "1494989219763",
                //     markedOrderId: "100",
                //     limit: "20",
                //     orderBy: "ORDER_DATE",
                //     ascending: "false",
                //     rel: "previous",
                //     test: ""
                // }
                var queryPairs;
                var queryValue;
                var parsedResult = null;
                if (queryString) {
                    queryPairs = queryString.split("?")[1].split("&");
                    parsedResult = {};
                    queryPairs.forEach(function(queryPair) {
                        queryPair = queryPair.split("=");
                        // PAYL-7433 Raw + (plus) symbols need to be converted
                        // to their encoded value so that they can be decoded
                        // correctly with decodeURIComponent.
                        // See this for more details:
                        // https://stackoverflow.com/questions/18717557/remove-plus-sign-in-url-query-string#answer-24417399
                        queryPair[1] = queryPair[1].replace(/\+/g, "%20");
                        queryValue = decodeURIComponent(queryPair[1] || "");
                        parsedResult[queryPair[0]] = queryValue;
                    });
                    parsedResult = JSON.parse(JSON.stringify(parsedResult));
                }
                return parsedResult;
            };

            $scope.$watch("paginate.pageLinks", function(pageLinks) {
                // convert the page links that are in the form of query parameter strings into objects that we can use throughout the rest of the code
                $scope.nextPageParameters = $scope.queryStringToObject(pageLinks && pageLinks.next);
                $scope.previousPageParameters = $scope.queryStringToObject(pageLinks && pageLinks.previous);
            }, true);

        };

        return expose;
    }
]);
